import React from 'react';
import { Card, Row } from 'react-bootstrap';
import style from './style.module.less';

function HintCard(props) {
  return (
    <Row style={props?.rowStyles ?? {}} className={props.noGutter ? '' : 'g-0'}>
      <Card style={props?.cardStyles ?? {}} className={`${style.rowResult} ${style.card}`}>
        <Card.Header style={props?.resultHeaderStyle ?? {}} className={style.resultHeader}>
          {props.text}
        </Card.Header>
      </Card>
    </Row>
  );
}

export default HintCard;
